import { zDriverLicenseCategory } from '@/general/src/insuranceDoc/driverLicense/shared.js'
import { getInsuranceDocMap, zClientInsuranceDocUploads } from '@/general/src/insuranceDoc/shared.js'
import { z } from 'zod'

const eptsCsvSrc = `Название поля в программе,alias,Название поля на фотографии в документе,Подсказка для ИИ,Валидация,Пример заполнения
Идентификационный номер (VIN),vin,Идентификационный номер (VIN),"17 символов, цифры и латинские буквы",обязательно,X96C41R13LEH00006
Марка,brand,Марка,"марка автомобиля, часто пишется вместе с моделью автомобиля, но находится перед ней",обязательно,Газ
Модель (коммерческое наименование),model,Коммерческое наименование,"модель автомобиля, часто пишется вместе с маркой автомобиля, но находится после нее",обязательно,ГАЗон NEXT
Категория ТС,category,"Категория в соответствии
с Конвенцией о дорожном движении","Аналогично категории прав. Буква или буква с цифрой, бывают: A, B, C, D, E, A1, B1, C1, D1, BE, CE, DE, C1E, D1E, M, Tm, Tb.",обязательно,С
Номер двигателя,engineNumber,Номер двигателя,"цифры и латинские буквы, может отсутствовать",опционально,отсутствует
Номер шасси (рамы),chassisNumber,Номер шасси (рамы),"цифры и латинские буквы, может отсутствовать",опционально,отсутствует
Номер кузова (кабины/прицепа),frameNumber,Номер кузова (кабины/прицепа),"цифры и латинские буквы, может отсутствовать, а может совпадать с VIN",опционально,X96C41R13LEH00006
Цвет кузова,color,"Цвет кузова (кабины, прицепа)","цвет транспортного средства, например ""зеленый""",обязательно,зеленый
Год выпуска,year,Год изготовления,год изготовления или выпуска транспортного средства,обязательно,2018
"ДВС (марка, тип)",engineType,"Двигатель внутреннего сгорания (марка, тип)","тип двигателя, например ""четырехтактный, двухцилиндровый""",опционально,"ЯМЗ 53444, четырёхтактный, с искровым зажиганием"
Рабочий объем цилиндров,engineDisplacement,Рабочий объем цилиндров (см. куб),Цифры,опционально,4430
"Мощность двигателя, кВТ",powerKw,Максимальная мощность (кВт),"В документе может называться просто мощность, но если есть приписка кВТ, то это оно",обязательно,110
"Мощность двигателя, л.с",powerHp,Максимальная мощность (л.с.),"В документе может называться просто мощность, но если есть приписка лс, то это оно. Если указано только лс или только кВТ. Высчитай недостающее поле сам исходя из того что 1 лс = 0,7355 кВТ",обязательно,150
Номер ЭПТС,number,Выписка из электронного паспорта транспортнрого средства №,"цифры, находятся в самом верху слева от qr-кода",обязательно,164301000121588
Дата выдачи ЭПТС,issuedDate,Дата выдачи ЭПТС,дата выдачи ЭПТС,обязательно,01.01.2020`

export const zEpts = z.object({
  vin: z.string().min(1),
  brand: z.string().min(1),
  model: z.string().min(1),
  category: zDriverLicenseCategory,
  engineNumber: z.string().optional(),
  chassisNumber: z.string().optional(),
  frameNumber: z.string().optional(),
  color: z.string().min(1),
  year: z.string().min(1),
  engineType: z.string().optional(),
  engineDisplacement: z.string().optional(),
  powerKw: z.string().min(1),
  powerHp: z.string().min(1),
  number: z.string().min(1),
  issuedDate: z.string().min(1),
})
export type EptsWithoutUploads = z.output<typeof zEpts>
export const zEptsWithUploads = z.object({
  insuranceDocsUploads: zClientInsuranceDocUploads,
  ...zEpts.shape,
})

export const eptsFieldsMap = getInsuranceDocMap({
  csv: eptsCsvSrc,
  zSchema: zEptsWithUploads,
  extra: {
    insuranceDocsUploads: { label: 'Фотография электронного ПТС (только лицевая сторона)' },
  },
})
export const getEptsFieldTitle = (field: keyof typeof eptsFieldsMap) => eptsFieldsMap[field].label
export const getEptsFieldHint = (field: keyof typeof eptsFieldsMap) => eptsFieldsMap[field].hint

export const eptsInitialValues: z.infer<typeof zEptsWithUploads> = {
  insuranceDocsUploads: [],
  vin: '',
  brand: '',
  model: '',
  category: '' as never,
  year: '',
  engineNumber: '',
  chassisNumber: '',
  frameNumber: '',
  color: '',
  engineType: '',
  engineDisplacement: '',
  powerKw: '',
  powerHp: '',
  number: '',
  issuedDate: '',
}

export const eptsExampleValues: z.infer<typeof zEptsWithUploads> = {
  insuranceDocsUploads: [],
  vin: '12345678901234567',
  brand: 'Toyota',
  model: 'Camry',
  category: 'A',
  year: '2020',
  engineNumber: '12345678901234567',
  chassisNumber: '12345678901234567',
  frameNumber: '12345678901234567',
  color: 'Красный',
  engineType: 'Бензиновый',
  engineDisplacement: '1.5',
  powerKw: '150',
  powerHp: '200',
  number: '164301000121588',
  issuedDate: '01.01.2020',
}
